<template>
  <div class="window" :style="{'paddingTop':statusBar + 'rem'}">
    <Header title="后台api接口异常测试" :back="true" right="" />
    <div class="windowmain">
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(302)">302异常</button>
        <button class="btn2" color="#2A7EFC" @click="submit(403)">403异常</button>
      </div>
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(404)">404异常</button>
        <button class="btn2" color="#2A7EFC" @click="submit(500)">500异常</button>
      </div>
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(502)">502异常</button>
        <button class="btn2" color="#F8F8F8" @click="submit(700)">访问数据接口</button>
      </div>
      <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(701)">模拟session过期（试用）</button>
        <button class="btn2" color="#F8F8F8" @click="submit(702)">模拟用户登录过期（试用）</button>
      </div>
	  <div class="btn">
        <button class="btn1" color="#F8F8F8" @click="submit(801)">获取用户信息</button>
        <button class="btn2" color="#F8F8F8" @click="submit(802)">备用</button>
      </div>
    </div>
  </div>
</template>

<script>
import { RadioGroup, Radio, Field } from 'vant';
import Header from '@/components/Header'

export default {
  name: 'home',
  /**
   * 初始化数据
   */
  data() {
    return {
      radio: '1',
      waybill: '',
      declareAtCustoms: '',
      transport: '',
      flight: '',
      container: '',
      backormoren: true,
      statusBar:0,
      //  ip: '',
    }
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);    
  },
  /**
   * 方法
   */
  methods: {
    submit(val){
      var path= '';
      if(val === 403){
        path='/desk/test/403';
      } else if(val === 404){
        path='/desk/test/404';
      }else if(val === 500){
         path='/desk/test/500';
      }else if(val === 302){
         path='/desk/test/302';
      }else if(val === 502){
         path='/desk/test/502';
      }else if(val === 700){
         path='/zsdyckserver/sw/getMenusJsonByMenuId?menu_id=dec001';
          this.$http.get(path).then(res => {
            window.console.log(res);
            this.$dialog.alert({
              message: JSON.stringify(res)
            }).then(() => {
            });
          })
          return;
      }else if(val === 701){
        path = '/zsdyckserver/j_spring_cas_security_logout?clientUrl=https%3A%2F%2Fapptest.singlewindow.cn%2Fzsdyckserver%2Fsw%2FgetMenusJsonByMenuId%3Fmenu_id%3Ddec001';
        this.$http.get(path).then(res => {
          window.console.log(res)
          this.$toast("session清除成功");
        })
        return;
      }else if(val === 702){
        path = '/cas/logout?service=https%3A%2F%2Fapptest.singlewindow.cn%2Fzsdyckserver%2Fsw%2FgetMenusJsonByMenuId%3Fmenu_id%3Ddec001&&logoutDomain=apptest.singlewindow.cn';
        this.$http.get(path).then(res => {
          window.console.log(res);
          this.$toast("tgc清除成功");
        })
        return;
      }else if(val === 801){
         path='/deskserver/sw/getAccountVO';
          this.$http.get(path).then(res => {
            window.console.log(res);
            this.$dialog.alert({
              message: JSON.stringify(res)
            }).then(() => {
            });
          })
          return;
      }
      this.$http.post(path).then(res => {
        window.console.log(res);
      })
    }
  },
  beforeDestroy() {
    if(this.backormoren){
      this.$tool.beforeDestroy(1);
    }
  },
  components:{
    Header,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Field.name]: Field,
  }
}
</script>

<style scoped lang="scss">
  .window{
    width: 100%;
    padding-top: 45px;
    .windowmain{
      background: #fff;
      overflow: auto;
      .btn{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 22px;
        .btn1{
          background: #F8F8F8;
          border: 1px solid $lineColor;
          border-radius: 4px;
          width: 119px;
          height: 44px;
          font-size: 17px;
          color: $fontColor;
        }
        .btn2{
          background: $themColor2;
          border: 1px solid $lineColor;
          border-radius: 4px;
          width: 119px;
          height: 44px;
          color: #fff;
          font-size: 17px;
          margin-left: 60px;
        }
      }
    }
  }
</style>